'use client';

import { useEffect, useState } from 'react';

export function useScrollThreshold({
  enabled = true,
  threshold = 75,
}: {
  threshold?: number;
  enabled?: boolean;
}): boolean {
  const [passed, setPassed] = useState(false);

  useEffect(() => {
    if (!enabled) return;

    const onScroll = () => {
      setPassed(window.scrollY > threshold);
    };

    onScroll();

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [enabled, threshold]);

  return passed;
}
